import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {omit, forEach} from 'lodash';

/*
 * "js/components/foo/bar.js" -> "foo.bar."
 * "js/utils/foo/bar.js" -> "utils.foo.bar."
 * "js/containers/foo/bar.js" -> "containers.foo.bar."
 */
const idPrefix = filename =>
  filename
    .replace('js/', '')
    .replace('components/', '')
    .replace(/\.js$/, '')
    .split('/').join('.')
  + '.';

const RosettaFormattedMessage = props =>
  <FormattedMessage
    id={idPrefix(props.parentFilename) + props.id}
    {...omit(props, ['id', 'parentFilename'])}
  />;

RosettaFormattedMessage.propTypes = {
  ...FormattedMessage.propTypes,
  // The value passed into this prop should ALWAYS be `__filename`
  parentFilename: PropTypes.string.isRequired
};

export default RosettaFormattedMessage;

/*
 * decorateIntlMessages
 * ====================
 * Given a `messages` object after it has been passed into `defineMessages`,
 * massage the ids so that they point to the right place (considering
 * the filename of the caller.)
 *
 * Usage in a component:
 *
 * const messages = decorateIntlMessages(__filename, defineMessages({
 *   foo: {
 *     id: "foo", // decorateIntlMessages makes this autoresolve
 *                // based on __filename
 *     description: "Foo message",
 *     defaultMessage: "Foo"
 *   }
 * }));
 */
export const decorateIntlMessages = (callerFilename, messages) => {
  const decoratedMessages = {};

  forEach(messages, (messageContent, messageLabel) => {
    decoratedMessages[messageLabel] = {
      ...messageContent,
      id: idPrefix(callerFilename) + messageContent.id
    };
  });

  return decoratedMessages;
};
